import http from '@/utils/http'

export function getTopics(params){
    return  http('/topics',{params})
}

export function getTopicsDetail(id){
    return  http(`/topics/${id}`)
}

export function getLastTopics(){
    return  http('/last_learning_topics')
}

export function getTopicsTest(id) {
    return http(`/topics/${id}/small_test`)
}

export function putTopicsAnswer(id, data) {
    return http.post(`/topics/${id}/small_test_answer_result`, data)
}

export function getLearningPerformance(params){
    return  http('/learningPerformance',{params})
}